<h2 mat-dialog-title>Auto log off warning - Idle</h2>
<div mat-dialog-content>
	You will be logged off in {{ data.countdown }} seconds.
	<div mat-dialog-actions class='px-0'>
		<button mat-dialog-close mat-stroked-button class="">Cancel</button>
	</div>
</div>
